import Home from "./pages/Home.jsx";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ScrollToTopWrapper from "./components/ScrollToTopWrapper.jsx";
import ProjectPage from "./pages/ProjectPage.jsx";
import Archive from "./pages/Archive.jsx";
import MouseFollower from "./components/ui/MouseFollower.jsx";
import LiveStatus from "./components/ui/LiveStatus.jsx";
import ScrollToTopButton from "./components/ui/ScrollToTopButton.jsx";
import SimpleLoader from "./components/ui/SimpleLoader.jsx";
import ProjectDetail from "./pages/ProjectDetail.jsx";
import I18nWrapper from "./components/I18nWrapper.jsx";
import { ThemeProvider } from "./contexts/ThemeContext.jsx";
import { NavigationProvider } from "./contexts/NavigationContext.jsx";
import { data } from "./data/pageData.js";
import "./i18n";
import { Analytics } from "@vercel/analytics/react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Component to handle hash navigation
const HashNavigationHandler = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash && location.pathname === '/') {
      // Remove the # from the hash
      const sectionId = location.hash.substring(1);

      // Wait a bit for the page to render, then scroll to the section
      const timeoutId = setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 100);

      return () => clearTimeout(timeoutId);
    }
  }, [location.hash, location.pathname]);

  return null;
};

function App() {
  return (
    <I18nWrapper>
      <ThemeProvider>
        <NavigationProvider>
          {/* Simple Loading Screen */}
          <SimpleLoader />

          <div className="min-h-screen bg-navy flex flex-col">
            <MouseFollower />
            <LiveStatus />
            <ScrollToTopButton />
            {/* Main App Container - Mobile First */}
            <div className="flex-1 flex flex-col w-full max-w-full overflow-x-hidden">
              <BrowserRouter>
                <HashNavigationHandler />
                <ScrollToTopWrapper>
                  {/* Centered Content Area */}
                  <div className="flex-1 flex flex-col items-center justify-start w-full">
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/archive" element={<Archive />} />
                      <Route
                        path="/project-detail/:id"
                        element={<ProjectDetail />}
                      />
                      <Route
                        path="/projects/:id"
                        element={<ProjectPage data={data} />}
                      />
                    </Routes>
                  </div>
                </ScrollToTopWrapper>
              </BrowserRouter>
            </div>
          </div>
        </NavigationProvider>
      </ThemeProvider>
      <Analytics />
    </I18nWrapper>
  );
}

export default App;
